import { createElement, ComponentType } from 'react';
import type { ReactNode } from 'react';

type ModuleWithDefault = { default: ComponentType };
export type RouteLoader = () => Promise<ModuleWithDefault>;

interface FastRouteLoaderParams {
    render: (node: ReactNode) => void;
    loader: RouteLoader;
}

/**
 * Generic fast path bootstrapper.
 * Handles rendering of isolated routes that don't need the full app context.
 */
export async function fastRouteLoader({
    render,
    loader
}: FastRouteLoaderParams): Promise<void> {
    try {
        const { default: Component } = await loader();
        render(createElement(Component));
    } catch (error) {
        console.error('Failed to load fast route. Falling back to main app.', error);
        // Fallback to main app if the fast route fails
        await loadMainApp(render);
    }
}

export async function loadMainApp(render: (node: ReactNode) => void): Promise<void> {
    await import('./i18n/i18n');
    await import('./index.css');
    const { default: App } = await import('./App');
    render(createElement(App));
}


